import { FULL_SCREEN_MODE, WINDOWED_MODE } from '@/vuex/types'

const isFullScreenMode = (state) => {
  return state.currentSlideMode === FULL_SCREEN_MODE
}

const isWindowedMode = (state) => {
  return state.currentSlideMode === WINDOWED_MODE
}

const isPresenting = (_state, getters) => {
  return (getters.isWindowedMode || getters.isFullScreenMode) && _state.route.name !== 'PresentationBackstage'
}

const isBackstage = (state) => {
  return state.route && state.route.name === 'PresentationBackstage'
}

const presentationHasNotes = (state) => {
  return state.presentation &&
    state.presentation.slides &&
    state.presentation.slides.some((slide) => slide.notes)
}

const isAbTestCollab = (state) => {
  if (state.presentation.accountId &&
    !state.presentation.hasSharedUser && state.presentation.accountId % 2 === 0) {
    return true
  }
  return false
}

const isTakenOwner = (state) => {
  return state.presentation &&
    state.currentUser &&
    state.presentation.takenOverBy === state.currentUser.id
}

const isDisableWhenNotOwner = (state) => {
  return isAbTestCollab(state) && !isTakenOwner(state)
}

const isAbTestWorkspace = (state) => {
  return isAbTestCollab(state) && state.presentation.accountId
}

export default {
  isFullScreenMode,
  isWindowedMode,
  isPresenting,
  isBackstage,
  presentationHasNotes,
  isTakenOwner,
  isAbTestCollab,
  isAbTestWorkspace,
  isDisableWhenNotOwner,
}
